import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=54417bac&scoped=true"
import script from "./privacy_policy.js?vue&type=script&lang=js&external"
export * from "./privacy_policy.js?vue&type=script&lang=js&external"
import style0 from "./privacy_policy.scss?vue&type=style&index=0&id=54417bac&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54417bac",
  null
  
)

export default component.exports